import EmployeeSettingsForms from '@/components/employees/employee-settings-forms'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/supervisor/employees/$employeeId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { employeeId } = Route.useParams()

  return <EmployeeSettingsForms employeeId={employeeId} />
}
